import React, { useEffect } from 'react';
import { IconButton, TextField, Card, Typography, Grid, Autocomplete, Checkbox, FormHelperText, Chip, Box, InputAdornment } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const formatValue = (value) => {
    if (typeof value !== 'string') {
      return value === 0 ? '0' : value?.toString() || '';
    }
    const formatted = value.replace(/^0+(?=\d)/, '').replace(/^\./, '0.');
    return formatted === '' ? '' : formatted;
};

const SelectedServices = ({ serviceList }) => {
  const { watch, setValue, formState: { errors }, register, trigger, setError, clearErrors } = useFormContext();
  const services = watch('serviceRelations') || [];

  const handleRemoveService = async (servicesMasterId, servicesChildId) => {
    const result = await Swal.fire({
      text: "Do you want to Delete Selected Service?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'No, Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
    }); 
    
    if (result.isConfirmed) {
      const updatedServices = services.filter(
        service => !(service.servicesMasterId === servicesMasterId && service.servicesChildId === servicesChildId)
      );
      setValue('serviceRelations', updatedServices, { shouldDirty: true });
      await trigger('serviceRelations');
    }
  };

// Show ALL services in the form that have valid IDs - not just "new" ones
const allFormServices = services.filter(service => 
  service && service.servicesMasterId && service.servicesChildId
);



// Get the actual service index in the full services array
const getActualServiceIndex = (service) => {
  return services.findIndex(s => 
    s && s.servicesMasterId === service.servicesMasterId && 
    s.servicesChildId === service.servicesChildId
  );
};
return (
  <Card>
    {allFormServices.map((service, displayIndex) => {      
      return (
        <Grid container key={`${service.servicesMasterId}-${service.servicesChildId}`} sx={{borderBottom:'1px solid #ccc',padding:'0.5rem'}} spacing={2}>
          <Grid item xs={3}>
            <Typography sx={{fontWeight:'600',fontSize:'0.75rem'}}>Category</Typography>
            <Typography sx={{fontSize:'0.75rem'}}>{service.subCategoryTitle}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography sx={{fontWeight:'600',fontSize:'0.75rem'}}>Master Service</Typography>
            <Typography sx={{fontSize:'0.75rem'}}>{service.masterServiceTitle}</Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography sx={{fontWeight:'600',fontSize:'0.75rem'}}>Child Service</Typography>
            <Typography sx={{fontSize:'0.75rem'}}>{service.childServiceTitle}</Typography>
          </Grid>
          <Grid item xs={0.5}>
            <IconButton
              onClick={() => handleRemoveService(service.servicesMasterId, service.servicesChildId)}
              size="small"
              color='error'
            >
              <DeleteIcon fontSize="small" color='error'/>
            </IconButton>
          </Grid>
        </Grid>
      );
    })}
  </Card>
);
}

export default SelectedServices;